import { themeGet } from 'styled-system'
import { Button } from 'components'

const PressButton = Button.extend`
  transition-duration: .03s;
  transition-property: transform, margin-bottom, border-bottom-width;
  margin-bottom: 0px;
  background-color: ${themeGet('colors.primary.0')};
  border-bottom-width: 5px;
  border-bottom-style: solid;
  border-bottom-color: ${themeGet('colors.primary.1')};
  text-shadow: 0px -2px ${themeGet('colors.primary.2')};
  &:active {
    transform: translate(0px,5px);
    border-bottom-width: 0px;
    margin-bottom: 5px;
  }
`

export default PressButton



// WEBPACK FOOTER //
// /opt/build/repo/src/components/PressButton.js